module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read')) ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "surveyViewPanel"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "surveyViewForm"
    }
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-12 col-lg-push-9",
    attrs: {
      "id": "meta-information-container"
    }
  }, [(_vm.surveyData) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectSurveyLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0051))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveyLanguage"
    },
    on: {
      "change": function($event) {
        return _vm.changeSurveyLanguage()
      }
    },
    model: {
      value: (_vm.surveyLocaleCode),
      callback: function($$v) {
        _vm.surveyLocaleCode = $$v
      },
      expression: "surveyLocaleCode"
    }
  }, _vm._l((_vm.surveyData.Languages), function(language) {
    return _c('option', {
      key: language.LocaleCode,
      domProps: {
        "value": language.LocaleCode
      }
    }, [_vm._v("\n              " + _vm._s(language.LocaleName) + "\n            ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.surveyData && _vm.surveyData.SurveyLogoId) ? _c('div', {
    staticClass: "survey-logo-container"
  }, [_c('img', {
    attrs: {
      "src": '/api/Download/' + _vm.surveyData.SurveyLogoId
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "id": "metaInformationHeader"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0000))]), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('b', [_vm._v("\n          " + _vm._s(_vm.lang.SV0013) + "\n          :\n        ")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.SurveyInstanceId) + "\n        "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showCheckHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showCheckHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showCheckHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0061))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0014) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.SurveyId) + "\n        "), (_vm.metaInformation.ShortSurveyCode) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0015) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.ShortSurveyCode) + "\n        ")] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0016) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationStoreId) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0017) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationName) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0018) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationAddress) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0019) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.LocationCountry) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0020) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.ScenarioName) + "\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0021) + ":")]), _vm._v("\n        " + _vm._s(_vm.metaInformation.WaveName) + "\n        "), (_vm.metaInformation.CarModelDistribution) ? _c('i', {
    staticClass: "material-icons md-18",
    staticStyle: {
      "vertical-align": "middle",
      "cursor": "pointer"
    },
    attrs: {
      "id": "carModelDistributionInfoIcon"
    }
  }, [_vm._v("drive_eta")]) : _vm._e(), _vm._v(" "), (
    _vm.metaInformation.CarModelDistribution ||
    _vm.metaInformation.CompetitorCarModelDistribution
  ) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "carModelDistributionInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [(_vm.metaInformation.CarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SV0060) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.metaInformation.CarModelDistribution), function(model) {
    return _c('span', {
      key: model.CarModelGuid
    }, [_vm._v("\n              " + _vm._s(model.CarModelName) + " - " + _vm._s(model.Distribution * 100) + "%\n              "), _c('br')])
  })] : _vm._e(), _vm._v(" "), (
    _vm.metaInformation.CarModelDistribution &&
    _vm.metaInformation.CompetitorCarModelDistribution
  ) ? [_c('br')] : _vm._e(), _vm._v(" "), (_vm.metaInformation.CompetitorCarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SV0062) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.metaInformation.CompetitorCarModelDistribution), function(model) {
    return _c('span', {
      key: model.CompetitorCarModelGuid
    }, [_vm._v("\n              " + _vm._s(model.CompetitorCarModel) + " - " + _vm._s(model.Distribution * 100) + "%\n              "), _c('br')])
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.metaInformation.WaveInfo) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0059) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.WaveInfo) + "\n        ")] : _vm._e(), _vm._v(" "), (_vm.metaInformation.SurveyInstanceInfo) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0057) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.SurveyInstanceInfo) + "\n        ")] : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole < 3) ? [_c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "surveyViewMetaInfoScoreSpan"
    }
  }, [_c('b', [_vm._v("\n              " + _vm._s(_vm.lang.SV0029) + "\n              "), _c('i', {
    staticClass: "material-icons md-18",
    staticStyle: {
      "vertical-align": "middle",
      "cursor": "pointer"
    }
  }, [_vm._v("help_outline")]), _vm._v("\n              :\n            ")]), _vm._v("\n            " + _vm._s(_vm.metaInformation.Score) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.metaInformation.ApprovedShopper) ? [_c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SV0063) + ":")]), _vm._v("\n          " + _vm._s(_vm.metaInformation.ApprovedShopper.DisplayName) + "\n          "), _c('div', {
    attrs: {
      "id": "approvedShopperDetailsContainer"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SV0064) + " (" + _vm._s(_vm.lang.SV0065) + "):\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.ShopperAge) + " (" + _vm._s(_vm.metaInformation.ApprovedShopper.Gender) + ")\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SV0066) + ":\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.ShopperCar) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SV0067) + ":\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.CarSegmentName) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SV0068) + ":\n            " + _vm._s(_vm.metaInformation.ApprovedShopper.CarModelName) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole < 3) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "surveyViewMetaInfoScoreSpan",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0030))]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputDateSurveyView"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0001) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputDateSurveyView')
      }
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDateSurveyView",
      "disabled": _vm.inputMetaInformationDisabled
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputDateSurveyView')
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputDateSurveyView')),
      expression: "inputHasError('inputDateSurveyView')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0012))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeInSurveyView"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0002) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        _vm.globals.toggleFlatpickr('inputTimeInSurveyView'),
          _vm.inputMetaInformationDisabled ||
          _vm.validateInput('inputTimeInSurveyView')
      }
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeInSurveyView",
      "disabled": _vm.inputMetaInformationDisabled
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputTimeInSurveyView')
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputTimeInSurveyView')),
      expression: "inputHasError('inputTimeInSurveyView')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0012))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeOutSurveyView"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0003) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        _vm.globals.toggleFlatpickr('inputTimeOutSurveyView'),
          _vm.inputMetaInformationDisabled ||
          _vm.validateInput('inputTimeOutSurveyView')
      }
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeOutSurveyView",
      "disabled": _vm.inputMetaInformationDisabled
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputTimeOutSurveyView')
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputTimeOutSurveyView')),
      expression: "inputHasError('inputTimeOutSurveyView')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0012))])])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputGPSSurveyViewLat"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-90",
      "max": "90",
      "id": "inputGPSSurveyViewLat",
      "disabled": _vm.inputMetaInformationDisabled
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0058))])])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputGPSSurveyViewLong"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-180",
      "max": "180",
      "id": "inputGPSSurveyViewLong",
      "disabled": _vm.inputMetaInformationDisabled
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SV0058))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "txtMemoShopper"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0004))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "txtMemoShopper",
      "disabled": _vm.globals.currentUserRole > 3 || _vm.surveyInstanceStatusId > 200
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "txtMemoAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0005))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "txtMemoAgency",
      "disabled": _vm.globals.currentUserRole > 2 || _vm.surveyInstanceStatusId > 200
    }
  })]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "txtMemoMSM"
    }
  }, [_vm._v(_vm._s(_vm.lang.SV0006))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "txtMemoMSM",
      "disabled": _vm.globals.currentUserRole > 1 || _vm.surveyInstanceStatusId > 200
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.surveyData && _vm.surveyData.SurveyAttachments) ? _c('div', {
    staticClass: "attachment-download-container",
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(_vm.surveyData.SurveyAttachments[0].DownloadId)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "attachmentDownloadButton"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.surveyData.SurveyAttachments[0].DownloadDescription ?
    _vm.surveyData.SurveyAttachments[0].DownloadDescription :
    _vm.surveyData.SurveyAttachments[0].DownloadFileName) + "\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "hidden-lg"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-xs-12 col-lg-pull-3"
  }, [(_vm.surveyData) ? _c('survey', {
    attrs: {
      "survey": _vm.survey
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.survey) ? _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.prevButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.survey.prevPage()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0007) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.nextButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.survey.nextPage()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0008) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    attrs: {
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Update') ||
        _vm.completeButtonDisabled ||
        _vm.saveRequestPending
    },
    on: {
      "click": function($event) {
        return _vm.validateSurvey()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.globals.currentUserRole == 3 ? _vm.lang.SV0009 : _vm.lang.SV0027) + "\n        "), (_vm.globals.currentUserRole == 3) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("flag")]) : _vm._e()])]), _vm._v(" "), (
    _vm.globals.currentUserRole < 3 &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')
  ) ? _c('div', {
    staticClass: "status-switch-container"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToShopperButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('shopper')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0024) + "\n      ")]), _vm._v(" "), (_vm.globals.currentUserRole == 1 || _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToAgencyButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('agency')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.feature.isAudiTarget ? _vm.lang.SV0069 : _vm.lang.SV0025) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToMSMButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('msm')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.feature.isAudiTarget ? _vm.lang.SV0070 : _vm.lang.SV0026) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole == 1 || _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": _vm.moveToMSMInternalButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.moveCheckTo('msminternal')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0028) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    class: {
      hidden: !_vm.isClosableWindow
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exitSurvey()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0010) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Update') ||
        _vm.saveButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.saveSurvey(false)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.lang.SV0011) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c('survey-upload-dialog', {
    attrs: {
      "showDialog": _vm.showUploadDialog,
      "questionData": _vm.questionData
    },
    on: {
      "dialogDataSaved": _vm.onUploadDialogDataSaved,
      "dialogClosed": _vm.onSurveyUploadDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-fab btn-fab-mini",
    attrs: {
      "id": "attachmentDownloadButton"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a04bcc46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyView/SurveyView.vue
// module id = 1715
// module chunks = 1